/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ModuleType } from './enums/module.type';
import {User} from './user';

export class History {
  ID: string;
  TYPE: HistoryType;
  FIELD_NAME: string;
  VALUE_PREV: string;
  VALUE_NEW: string;
  DATE: Date;
  USER: User;
  NOTE: string;
  MODULE_TYPE: ModuleType;

  static parse(json: any): History {
    if (json) {
      const h = new History();

      h.ID = json.ID;
      h.TYPE = HistoryType[<string>json.TYPE];
      h.FIELD_NAME = json.FIELD_NAME;
      h.VALUE_PREV = json.VALUE_PREV;
      h.VALUE_NEW = json.VALUE_NEW;
      h.DATE = json.DATE;
      h.USER = User.parse(json.USER);
      h.NOTE = json.NOTE;
      h.MODULE_TYPE = ModuleType[<string>json.MODULE_TYPE];

      return h;
    } else return null;
  }

  static parseArray(json: any[]): History[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(History.parse(j));

    return arr;
  }
}

export class HistorySummary {
  ITEM_COUNT: number;
  ITEM_DATE: string;

  static parse(json: any): HistorySummary {
    if (json) {
      const h = new HistorySummary();

      h.ITEM_COUNT = Number(json.ITEM_COUNT);
      h.ITEM_DATE = json.ITEM_DATE;

      return h;
    } else return null;
  }

  static parseArray(json: any[]): HistorySummary[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(HistorySummary.parse(j));

    return arr;
  }
}

export enum HistoryType {
  DATA = 'DATA',
  STAGE = 'STAGE',
  STATUS = 'STATUS',
  DOCUMENT = 'DOCUMENT',
  ASK_QUESTIONS = 'ASK_QUESTIONS',
  NUMBER = 'NUMBER'
}
